<template>
  <div id="AdminRoutes" class="container h-100 overflow-auto py-4">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-10">
        <h1 class="mb-1">Admin</h1>
        <p class="text-body-tertiary mb-4">
          All admin tools, grouped by workflow. Press <kbd>⌘K</kbd> anywhere to
          search.
        </p>

        <div class="row g-4">
          <div
            v-for="group in adminNavGroups"
            :key="group.label"
            class="col-12 col-md-6"
          >
            <div class="card h-100">
              <div class="card-body">
                <h5 class="card-title text-uppercase fs-9 text-body-tertiary">
                  {{ group.label }}
                </h5>
                <div class="list-group list-group-flush">
                  <router-link
                    v-for="item in visibleItems(group)"
                    :key="item.id"
                    :to="{ name: item.routeName, query: item.query }"
                    class="list-group-item list-group-item-action px-0"
                  >
                    <div class="d-flex align-items-center">
                      <font-awesome-icon
                        :icon="item.icon"
                        class="me-3 text-body-tertiary"
                        fixed-width
                      />
                      <div>
                        <div class="fw-semibold">{{ item.label }}</div>
                        <small
                          v-if="item.description"
                          class="text-body-tertiary"
                        >
                          {{ item.description }}
                        </small>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  adminNavGroups,
  type AdminNavGroup,
  type AdminNavItem,
} from "@/admin/navigation/adminNavConfig";

const visibleItems = (group: AdminNavGroup): AdminNavItem[] =>
  group.items.filter((item) => !item.paletteOnly);
</script>
